import type { FormSchema, GeneratedFile, Schema } from '@cli-types/core-engine/schema.js'
import type { SnapshotManifest } from '@cli-types/core-engine/snapshots.js'
import { hashContent } from '@cli-utils/files.js'

export function createManifest(
  scope: string,
  schemaJson: Schema | FormSchema | { name: string },
  cliVersion: string,
  files: GeneratedFile[],
  skipped: string[]
): SnapshotManifest {
  return {
    schemaName: scope,
    schemaHash: hashContent(JSON.stringify(schemaJson)),
    schemaJson,
    cliVersion,
    generatedAt: new Date().toISOString(),
    files: files.map((file) => ({
      path: file.path,
      hash: hashContent(file.content)
    })),
    skipped: [...skipped].sort()
  }
}
